// client/src/App.js
import React, { useState, useEffect, useRef } from 'react';
import './App.css';

// You can easily add, remove, or change your playlists here
const myPlaylists = [
  { name: "Lofi Girl x Assassin's Creed Shadows - Stealthy beats to relax to", id: 'PL6NdkXsPL07KN01gH2vucrHCEyyNmVEx4' },
  { name: 'Top Music 2025', id: 'PLOHoVaTp8R7esHFifrUPQSVXkwz1WYIzk' },
  { name: 'NCS - Most Popular', id: 'PLRBp0Fe2GpgnIh0AiYKh7o7HnYAej-5ph' },
  { name: 'Nepali Popular Music on YouTube', id: 'RDkJTgA-aBwZA' }
];

// This assumes you have the Nginx proxy set up.
const API_URL = '/api';

function App() {
  // The playlistId state is now initialized with the first playlist from your list
  const [playlistId, setPlaylistId] = useState(myPlaylists[0].id);

  const [videos, setVideos] = useState([]);
  const [player, setPlayer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const playerRef = useRef(null);

  // Effect to load the IFrame Player API script
  useEffect(() => {
    const createPlayer = () => {
      playerRef.current = new window.YT.Player('youtube-player', {
        height: '390',
        width: '640',
        videoId: '',
        playerVars: {
          'playsinline': 1
        },
        events: {
          onReady: (event) => setPlayer(event.target),
          onError: (event) => setError(`Youtubeer Error: ${event.data}`),
        },
      });
    };

    if (window.YT && window.YT.Player) {
      createPlayer();
    } else {
      const tag = document.createElement('script');
      // Corrected the YouTube IFrame API URL
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.onYouTubeIframeAPIReady = createPlayer;
    }

    return () => {
      if (playerRef.current) playerRef.current.destroy();
      window.onYouTubeIframeAPIReady = null;
    };
  }, []);

  // Effect to fetch playlist videos (this logic does not need to change)
  useEffect(() => {
    if (!playlistId) return;

    const fetchPlaylistItems = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_URL}/playlist/${playlistId}`);
	const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Could not fetch playlist. Check your API Key.');
        }

        setVideos(data);
        if (data.length > 0 && player) {
            player.cueVideoById(data[0].snippet.resourceId.videoId);
        }

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPlaylistItems();
  }, [playlistId, player]);

  const handleVideoSelect = (videoId) => {
    if (player) {
      player.loadVideoById(videoId);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>YouTube Playlist Viewer</h1>

        {/* This dropdown menu allows users to select a playlist */}
        <div className="playlist-selector">
          <label htmlFor="playlist-select">Choose a playlist: </label>
          <select
            id="playlist-select"
            value={playlistId}
            onChange={(e) => setPlaylistId(e.target.value)}
          >
            {myPlaylists.map((playlist) => (
              <option key={playlist.id} value={playlist.id}>
                {playlist.name}
              </option>
            ))}
          </select>
        </div>
      </header>
      <main className="playlist-layout">
        <div className="video-player-container">
            <div id="youtube-player"></div>
        </div>
        <div className="video-list-container">
            <h2>Playlist Videos</h2>
            {loading && <p>Loading playlist...</p>}
            {error && <p className="error">{error}</p>}
            <ul className="video-list">
              {videos.map((video) => (
                <li key={video.id} onClick={() => handleVideoSelect(video.snippet.resourceId.videoId)}>
                  <img src={video.snippet.thumbnails.medium.url} alt={video.snippet.title} />
                  <div className="video-title">{video.snippet.title}</div>
                </li>
              ))}
            </ul>
        </div>
      </main>
    </div>
  );
}

export default App;
